export const environment = {
  production: true,
  appName: 'Stem E-Commerce',
  apiUrl: 'https://stem-ecomm-public.kedos-srl.it/public-prod/rest/',
  configuratoreApiUrl: 'https://step-api.stem.it/CGStem/struttura/',
  baseHref: null,

  tabletBreakpoint: 1024,
  mobileBreakpoint: 768,

  allegati: {
    filePath: 'https://d3c4hbqwq5ie8d.cloudfront.net/images/',
  },

  schedePerPagina: 6,

  graphHopperApiKey: '4b0d1a43-c9ff-4090-a00a-724dca077e73LOCKED',
  googleApiKey: 'AIzaSyCW-8r6dDioYLvbfhCq7IXVjtwJo9XwWcoLOCKED',

  linkTracking: 'http://www.simplyline.net/SimplyWeb/LOCKED'
};




